// extracted by mini-css-extract-plugin
export default {"block":"NS0VMmGiRrw40tdJh0JD","scholasticSetNewPassword":"rw5rjVKo5rTS06mBwvCv"};